import { Icon, Text } from '@pm/ui';

const StepGroup = ({
  title,
  description,
  liClassName = '',
}: {
  title: string;
  description: React.ReactNode | string;
  liClassName?: string;
}) => {
  return (
    <li className={liClassName}>
      <div className="flex flex-row gap-m items-start">
        <Icon
          name="check_circle"
          size="large"
          filled
          color="text-content-positive"
        />
        <Text size="headingXS" as="h2">
          {title}
        </Text>
      </div>
      <div className="ml-[calc(24px+16px)] mt-xxs">
        <Text size="bodyL" color="contentSubdued">
          {description}
        </Text>
      </div>
    </li>
  );
};

export default StepGroup;
